export default "__VITE_ASSET__b9c71e26__"